import { IJSONStorage } from './storage.interface';

export class JSONStorage<T = unknown> implements IJSONStorage<T> {
  readonly #storage: Storage;
  readonly #key: string;

  constructor(browserStorage: Storage, key: string) {
    this.#storage = browserStorage;
    this.#key = key;
  }

  getItem(): Readonly<T> | null {
    const v = this.#storage.getItem(this.#key);
    return v ? JSON.parse(v) : null;
  }

  setItem(value: T) {
    this.#storage.setItem(this.#key, JSON.stringify(value));
  }

  clear() {
    this.#storage.removeItem(this.#key);
  }

  has(): boolean {
    return this.#storage.getItem(this.#key) !== null;
  }
}
